import { render, staticRenderFns } from "./DashboardViewEditingAccess.vue?vue&type=template&id=b4030060"
import script from "./DashboardViewEditingAccess.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditingAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports